<template>
  <div v-if="dataPermission?.includes('CNPS_DEVICE_VIEW')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách Sim đi kèm Tingbox - cho MC tự kích hoạt</h1>
      <div class="float-right btn-group">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button
          @click="openAddModal"
          v-if="dataPermission?.includes('CNPS_DEVICE_IMPORT_FILE_LINK_DEVICE')"
          class="font-medium f12 btn btn-outline-secondary"
        >
          <i class="bx bx-plus-circle"></i> Thêm mới
        </button>
        <button
          v-if="dataPermission?.includes('CNPS_DEVICE_IMPORT_FILE_LINK_DEVICE')"
          class="font-medium f12 btn btn-outline-secondary"
          @click="$refs.fileInput.click()"
        >
          <i class="bx bx-plus-circle"></i> Import file
        </button>
        <button @click="exportExcel" class="font-medium f12 btn btn-outline-secondary">
          <i class="bx bx-download"></i> Tải file mẫu
        </button>
        <input
          type="file"
          ref="fileInput"
          @change="onFileChange"
          accept=".xlsx, .xls"
          style="display: none"
        />
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"></VueLoadingOverlay>
    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.serial"
              class="form-control f12 hc-37"
              placeholder="Từ khóa"
              @keydown.enter.prevent="fetchData"
            />
          </div>

          <div class="form-group">
            <Select2 v-model="search.keeperIds" :options="dataKeeper" placeholder="Thủ kho" />
          </div>
          <div class="form-group">
            <Select2 v-model="search.status" :options="optionStatus" placeholder="Trạng thái" />
          </div>
          <div class="form-group">
            <Select2 v-model="search.regionId" :options="dataConfigRegion" placeholder="Vùng" />
          </div>

          <div class="form-group form-group-action">
            <button
              @click="fetchData"
              class="pt-2 mr-2 btn btn-primary hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button
              @click="removeForm"
              type="button"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <span><b>Tổng số</b>: {{ pagination.total }}</span>
            <b-table
              :busy.sync="loading"
              sticky-header
              hover
              responsive
              :items="dataListSim"
              :fields="filterTable"
              bordered
              fixed
              show-empty
            >
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #empty>
                <div class="text-center text-info my-2">Không có dữ liệu</div>
              </template>
              <template #emptyfiltered="{ emptyFilteredText }">
                <h4>{{ emptyFilteredText }}</h4>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(collectMoney)="data">
                <p v-if="data.item?.collectMoney">
                  {{ data.item?.collectMoney ? 'Thu tiền riêng' : 'Thu tiền chung' }}
                </p>
              </template>
              <template #cell(kepperName)="data">
                <p>{{ data.item.keeperName }}</p>
                <p>{{ data.item.keeperEmail }}</p>
              </template>

              <template #cell(status)="data">
                <b-badge class="font-size-12" :class="getStatuBgColor(data.item.status)">
                  {{ data.item.status | transformData(optionStatus) }}
                </b-badge>
              </template>

              <template #cell(action)="data">
                <button
                  v-if="data.item.status === 'FAIL'"
                  class="btn btn-outline-danger"
                  @click="retryError(data.item)"
                >
                  <i class="bx bx-refresh"></i> Tải lại
                </button>

                <!-- <b-dropdown
                  id="dropdown-1"
                  class="m-md-2"
                  variant="outline-light"
                >
                  <b-dropdown-item
                  @click="toDetail(data.item)">
                    Chi tiết
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="$router.push({ path: `/cat-device/edit/${data.item.id}` })"
                    v-if="data.item.status == 'ACTIVE' && dataPermission.includes('CNPS_DEVICE_CATEGORY_UPDATE')">Sửa
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="LocknUnlock(data.item)"
                    v-if="data.item.status == 'ACTIVE' && dataPermission.includes('CNPS_DEVICE_CATEGORY_UPDATE')">Khoá
                  </b-dropdown-item>
                  <b-dropdown-item
                    @click="LocknUnlock(data.item)"
                    v-if="data.item.status != 'ACTIVE' && dataPermission.includes('CNPS_DEVICE_CATEGORY_UPDATE')">Mở khoá
                  </b-dropdown-item>
                </b-dropdown> -->
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="pagination-bottom">
        <b-pagination
          class="mr-2 fl-right"
          v-model="search.page"
          :total-rows="pagination.total"
          :per-page="search.limit"
        ></b-pagination>
      </div>
    </div>

    <!-- Modal thông báo -->
    <b-modal id="modal-scoped" centered v-model="notiModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          @click="close()"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" :alt="iconNoti" />
        <h2 class="py-3 f18">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>

    <!-- Modal thêm mới -->
    <b-modal
      id="modal-add-new"
      v-model="showAddModal"
      :no-close-on-backdrop="true"
      centered
      @cancel="closeModelAdd()"
      size="lg"
    >
      <template #modal-header="{ close }">
        <h4>Thêm mới sim kèm Tingbox</h4>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          @click="
            close()
            closeModelAdd()
          "
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <div class="form-group" style="width: 100%; padding: 10px">
        <label for="serialTingBox">Kho</label>
        <SearchStaffAutocomplete
          v-model="filterAdd.inventories"
          :disabled="optionInventory.length === 0"
          :list="optionInventory"
          placeholder="Chọn kho"
          size="md"
          @input="handleChange"
          :maxShow="50"
        />
        <!-- <Select2
              v-model="filterAdd.inventories"
              :options="optionInventory"
              placeholder="Tên kho"
            ></Select2> -->
      </div>
      <div style="display: flex; gap: 10px; padding: 10px">
        <div class="form-group" style="width: 100%">
          <label for="serialTingBox">Thiết bị tingbox</label>
          <SearchStaffAutocomplete
            v-model="filterAdd.categoryId"
            :list="optionType"
            placeholder="Loại thiết bị"
            size="md"
            @input="loadListDevice"
          />
        </div>
        <div class="form-group" style="width: 100%">
          <label for="serialTingBox">Serial TingBox</label>
          <SearchStaffAutocomplete
            size="md"
            id="serialTingBox"
            v-model="newDevice.serialTingBox"
            :class="{ 'is-invalid': errorAdd.serialTingBox }"
            :placeholder="loadingTingBox ? 'Loading...' : 'Tìm kiếm/Chọn thiết bị'"
            :list="optionChonseDeviceAdd"
            :disabled="loadingTingBox"
          />
          <div class="invalid-feedback" v-if="errorAdd.serialTingBox">
            {{ errorAdd.serialTingBox }}
          </div>
        </div>
      </div>
      <div style="display: flex; gap: 10px; padding: 10px">
        <div class="form-group" style="width: 100%">
          <label for="serialTingBox">Thiết bị sim đi kèm</label>
          <SearchStaffAutocomplete
            size="md"
            v-model="filterAdd.categoryIdSim"
            :list="optionTypeSim"
            placeholder="Loại thiết bị sim"
            @input="loadListDeviceSim"
          />
        </div>
        <div class="form-group" style="width: 100%">
          <label for="serialSim">Serial Sim</label>
          <SearchStaffAutocomplete
            size="md"
            id="serialSim"
            :list="optionChonseDeviceSimAdd"
            v-model="newDevice.serialSim"
            :class="{ 'is-invalid': errorAdd.serialSim }"
            :placeholder="loadingSim ? 'Loading...' : 'Tìm kiếm/Chọn sim'"
            :disabled="loadingSim"
          />
          <div class="invalid-feedback" v-if="errorAdd.serialSim">
            {{ errorAdd.serialSim }}
          </div>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100" style="display: flex; justify-content: space-between">
          <b-checkbox v-model="newDevice.collectMoney">
            <p style="font-weight: 600; font-family: 'Roboto', sans-serif; font-size: 16px">
              Sim thu tiền riêng (user cần cập nhật phiếu thu sim)
            </p>
          </b-checkbox>
          <div>
            <button class="btn btn-secondary" @click="closeModelAdd">Hủy</button>
            <button class="btn btn-primary ml-2" @click="submitNewDevice" :disabled="isSubmitting">
              <b-spinner small v-if="isSubmitting"></b-spinner>
              Xác nhận
            </button>
          </div>
        </div>
      </template>
    </b-modal>
    <!-- Modal kết quả import -->
    <b-modal id="modal-import-result" v-model="showImportResultModal" size="md" centered>
      <template #modal-header="{ close }">
        <h5>Import file thành công</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          @click="close()"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <div class="text-center mb-4">
        <div class="text-center">
          <p style="text-align: center">
            <strong>Số bản ghi thành công:</strong>
            {{ importResultData?.listCorrect?.length || 0 }}
          </p>
          <p style="text-align: center">
            <strong>Số bản ghi thất bại:</strong>
            {{ importResultData?.listError?.length || 0 }}
          </p>
          <button
            style="font-weight: 400"
            class="btn btn-outline-danger mt-2"
            @click="exportErrorFile"
          >
            Tải bản ghi thất bại
          </button>
        </div>
      </div>

      <template #modal-footer>
        <button class="btn btn-primary" @click="showImportResultModal = false">OK</button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import prepareQueryParamsMixin from '../../../mixins/prepareQueryParamsMixin'
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import Config from '@/thirdParty/config'
  import { DeviceService } from '@/services/device.service'
  import { mapGetters } from 'vuex'
  import SearchStaffAutocomplete from '@/components/cskh/SearchStaffAutocomplete.vue'
  import { StaffService } from '@/services/staff.service'

  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'serialSim', label: 'Mã Sim' },
    { key: 'serialTingBox', label: 'Mã TingBox' },
    { key: 'kepperName', label: 'Thủ kho' },
    { key: 'collectMoney', label: 'Cách thu tiền' },
    { key: 'status', label: 'Trạng thái xuất TB SIM' },
    { key: 'message', label: 'Lý do lỗi' },
    { key: 'action', label: 'Thao tác' },
  ]
  export default {
    components: {
      SearchStaffAutocomplete,
    },
    mixins: [prepareQueryParamsMixin],
    computed: {
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          size: this.search.size,
          page: this.search.page,
        })
      },
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      getStatuBgColor() {
        return status => {
          const map = this.optionStatus.reduce((acc, cur) => {
            acc[cur.id] = cur.bgColor
            return acc
          }, {})
          return map[status] || 'badge-info'
        }
      },
    },
    watch: {
      'search.page': function () {
        this.fetchData()
      },
    },
    filters: {
      transformData(data, dataConfig) {
        const dataReturn = dataConfig.filter(e => e.id === data)
        if (dataReturn.length === 0) {
          return ''
        }
        return dataReturn[0].text
      },
    },
    data() {
      return {
        loading: false,
        showLoading: false,
        search: {
          page: 1,
          limit: 20,
        },
        dataListSim: [],
        pagination: {
          total: 0,
        },
        fieldsTable,
        filterTable: fieldsTable,
        Config,
        // Notification modal data
        notiModal: false,
        msgNoti: '',
        iconNoti: '',
        // Add new modal data
        showAddModal: false,
        newDevice: {
          serialTingBox: '',
          serialSim: '',
          collectMoney: true,
        },
        errorAdd: {
          serialTingBox: '',
          serialSim: '',
        },
        isSubmitting: false,
        showImportResultModal: false,
        importSuccess: false,
        importResultMessage: '',
        importResultData: null,
        optionStatus: [
          { id: 'NEW', text: 'Mới tạo', bgColor: 'bg-primary' },
          { id: 'PROCESS', text: 'Chờ duyệt', bgColor: 'bg-warning' },
          { id: 'DONE', text: 'Hoàn thành', bgColor: 'bg-success' },
          { id: 'FAIL', text: 'Thất bại', bgColor: 'bg-danger' },
        ],
        dataUser: JSON.parse(localStorage.getItem('userData')),
        filterAdd: { categoryId: '', categoryIdSim: '', inventories: '' },
        optionInventory: [],
        optionType: [],
        optionTypeSim: [],
        loadingSim: false,
        loadingTingBox: false,
        optionChonseDeviceAdd: [],
        optionChonseDeviceSimAdd: [],
        dataConfigRegion: [],
        dataKeeper: [],
      }
    },
    created() {
      this.fetchData()
      this.getListInventory()
      this.typeDevice()
      this.getRegions()
      this.fetchManager()
    },
    methods: {
      removeForm() {
        this.search = {
          page: 1,
          limit: 20,
        }
        this.fetchData()
      },
      async fetchManager() {
        try {
          const { data } = await StaffService.getStaffByIdSuperior({
            userId: this.dataUser.userId,
          })
          this.dataKeeper = data.map(e => {
            return {
              id: e.userId,
              text: `${e.name} - ${e.userName}`,
            }
          })
          this.dataKeeper.unshift({ id: '0', text: 'Tất cả' })
        } catch (e) {
          console.error(e)
        }
      },
      async getRegions() {
        const data = await StaffService.getRegions()
        if (data.data.length > 0) {
          this.dataConfigRegion = data.data.map(e => {
            return {
              id: e.id,
              text: e.name,
            }
          })
          this.dataConfigRegion.unshift({ id: '0', text: 'Tất cả' })
        }
      },
      closeModelAdd() {
        this.showAddModal = false
        this.filterAdd = {
          categoryId: '',
          categoryIdSim: '',
          inventories: '',
        }
        this.optionChonseDeviceAdd = []
        this.optionChonseDeviceSimAdd = []
      },
      handleChange(id) {
        this.newDevice.collectMoney = true
        this.filterAdd.categoryId = ''
        this.filterAdd.categoryIdSim = ''
        this.newDevice.serialTingBox = ''
        this.newDevice.serialSim = ''
      },

      async retryError(item) {
        // AI

        this.showLoading = true // AI
        try {
          // AI

          const res = await DeviceService.RetrySim(item) // AI
          if (res.code === 1000) {
            // AI

            this.fetchData() // AI
            this.showSuccessMx(res.message || 'Tải lại thành công') // AI
          } else {
            this.showErrorMx(res.message || 'Đã xảy ra lỗi') // AI
          }
        } catch (error) {
          // AI
          this.showErrorMx(error.data.message || 'Đã xảy ra lỗi') // AI

          console.error('Error loading device list:', error) // AI
        } finally {
          // AI
          this.showLoading = false // AI
        }
      },

      // AI
      async exportErrorFile() {
        this.showLoading = true
        try {
          const payload = this.importResultData?.listError || []
          await DeviceService.downloadFileErrorSim(payload)
        } catch (error) {
          console.error('Error loading device list:', error)
        } finally {
          this.showLoading = false
        }
      },
      // AI

      async loadListDevice() {
        try {
          this.loadingTingBox = true

          // Clean up filter parameters
          if (this.filterAdd.categoryId === '0') delete this.filterAdd.categoryId
          if (this.filterAdd.inventories === '0') delete this.filterAdd.inventories

          // First API call with minimal parameters to get total count
          const initialResponse = await DeviceService.listDevice({
            ...(this.filterAdd.inventories && {
              inventoryIds: [this.filterAdd.inventories],
            }),
            categoryId: this.filterAdd.categoryId,
            page: 1,
            limit: 1, // Minimal limit to just get count
            sortResultList: [
              {
                field: 'serial',
                direction: 'DESC',
              },
            ],
          })

          if (initialResponse.code === 1000 && initialResponse.data) {
            const totalCount = initialResponse.data.count || 0

            if (totalCount > 0) {
              // Second API call with limit set to total count to get all devices
              const fullResponse = await DeviceService.listDevice({
                ...(this.filterAdd.inventories && {
                  inventoryIds: [this.filterAdd.inventories],
                }),
                categoryId: this.filterAdd.categoryId,
                page: 1,
                limit: totalCount,
                sortResultList: [
                  {
                    field: 'serial',
                    direction: 'DESC',
                  },
                ],
              })

              if (fullResponse.code === 1000 && fullResponse.data) {
                this.optionChonseDeviceAdd =
                  fullResponse.data.devices.map(e => ({
                    id: e.serial,
                    text: e.serial,
                  })) || []
              }
            } else {
              this.optionChonseDeviceAdd = []
            }
          }
        } catch (error) {
          console.error('Error loading device list:', error)
        } finally {
          this.loadingTingBox = false
        }
      },

      // AI
      async loadListDeviceSim() {
        try {
          this.loadingSim = true

          // Clean up filter parameters
          if (this.filterAdd.categoryIdSim === '0') delete this.filterAdd.categoryIdSim
          if (this.filterAdd.inventories === '0') delete this.filterAdd.inventories

          // Create parameters for Sim devices
          const simParams = {
            ...(this.filterAdd.inventories && {
              inventoryIds: [this.filterAdd.inventories],
            }),
            categoryId: this.filterAdd.categoryIdSim, // Use categoryIdSim as categoryId for this call
            page: 1,
            limit: 1, // Minimal limit to just get count
            sortResultList: [
              {
                field: 'serial',
                direction: 'DESC',
              },
            ],
          }

          // First API call with minimal parameters to get total count
          const initialResponse = await DeviceService.listDevice(simParams)

          if (initialResponse.code === 1000 && initialResponse.data) {
            const totalCount = initialResponse.data.count || 0

            if (totalCount > 0) {
              // Second API call with limit set to total count to get all devices
              const fullResponse = await DeviceService.listDevice({
                ...simParams,
                limit: totalCount,
              })

              if (fullResponse.code === 1000 && fullResponse.data) {
                this.optionChonseDeviceSimAdd =
                  fullResponse.data.devices.map(e => ({
                    id: e.serial,
                    text: e.serial,
                  })) || []
              }
            } else {
              this.optionChonseDeviceSimAdd = []
            }
          }
        } catch (error) {
          console.error('Error loading sim device list:', error)
        } finally {
          this.loadingSim = false
        }
      },

      // AI
      async typeDevice() {
        try {
          const data = await DeviceService.typeDeviceConfig()
          if (data.success) {
            // Lọc các thiết bị có nickname nằm trong danh sách cần lấy
            const filteredData = data.data.filter(e =>
              [
                'TingBox02',
                'TingBox01',
                'TingBox',
                'TingBoxS',
                'TingBoxPRO',
                'TingBoxS2',
                'TingBoxS3',
                'TingBoxP1',
              ].includes(e.nickname)
            )

            this.optionType = filteredData.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            }) // AI

            // Lọc các thiết bị có nickname bắt đầu bằng "SIM"
            const filteredSimData = data.data.filter(
              e => e.nickname && e.nickname.startsWith('SIM')
            )

            // Sắp xếp theo nickname
            filteredSimData.sort((a, b) => a.nickname.localeCompare(b.nickname))

            this.optionTypeSim = filteredSimData.map(e => {
              return {
                id: e.id,
                text: e.name,
              }
            }) // AI
          }
        } catch (error) {
          console.log(error)
        }
      },
      async getListInventory() {
        try {
          const data = await DeviceService.getListWarehouseUserActive()
          if (data.success) {
            const body = data.data.map(e => {
              return {
                ...e,
                text: e.name,
              }
            })
            body.unshift({ id: '0', text: 'Tất cả', regions: [], level: '' })
            this.optionInventory = body.filter(
              e => e.type === 'MC_SELF_ONBOARD' || e.type === 'EMPLOYEE'
            )
          }
        } catch (error) {
          console.log(error)
        }
      },

      async fetchData() {
        try {
          this.loading = true
          const res = await DeviceService.listTingboxsim({
            ...this.search,
            ...(this.search.keeperIds && { keeperIds: [this.search.keeperIds] }),
          })
          if (res.code === 1000) {
            this.dataListSim = res.data?.linkDevices || []
            this.pagination.total = res.data?.count || 0
          } else {
            // Handle non-success response codes
            this.msgNoti = `Lỗi: ${res.message || 'Không thể tải danh sách thiết bị'}`
            this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
            this.notiModal = true
          }
        } catch (error) {
          // Add error notification here
          this.msgNoti = `Đã xảy ra lỗi: ${error.message || 'Không thể kết nối đến máy chủ'}`
          this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
          this.notiModal = true
        } finally {
          this.loading = false
        }
      },

      // Get index for table rows
      getIndex(index) {
        return (this.search.page - 1) * this.search.limit + index + 1
      },

      // Open the add new modal
      openAddModal() {
        // Reset the form and errors
        this.newDevice = {
          serialTingBox: '',
          serialSim: '',
          collectMoney: true,
        }
        this.errorAdd = {
          serialTingBox: '',
          serialSim: '',
        }
        this.showAddModal = true
      },

      // Submit the new device to the API
      async submitNewDevice() {
        try {
          // Reset error messages
          this.errorAdd = {
            serialTingBox: '',
            serialSim: '',
          }

          // Validate form
          let isValid = true

          if (!this.newDevice.serialTingBox) {
            this.errorAdd.serialTingBox = 'Vui lòng nhập Serial TingBox'
            isValid = false
          }

          if (!this.newDevice.serialSim) {
            this.errorAdd.serialSim = 'Vui lòng nhập Serial Sim'
            isValid = false
          }

          if (!isValid) {
            return
          }

          this.isSubmitting = true

          // Call the API to add new device
          const response = await DeviceService.addTingboxsim(this.newDevice)

          if (response.code === 1000) {
            // Success
            this.msgNoti = 'Thêm mới thiết bị thành công'
            this.iconNoti = require('@/assets/img/noti-success2.svg')
            this.notiModal = true
            this.showAddModal = false

            // Refresh the data
            this.fetchData()
          } else {
            // API returned error
            this.msgNoti = response.data || response.message || 'Thêm mới không thành công'
            this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
            this.notiModal = true
          }
        } catch (error) {
          console.error('Error adding new device:', error)
          this.msgNoti = `Đã xảy ra lỗi: ${error.message || 'Không thể kết nối đến máy chủ'}`
          this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
          this.notiModal = true
        } finally {
          this.isSubmitting = false
        }
      },
      async importFile(file) {
        try {
          this.showLoading = true

          // Tạo FormData để gửi file
          const formData = new FormData()
          formData.append('file', file)

          // Gọi API import file
          const response = await DeviceService.importFileSimTingBox(formData)

          this.showLoading = false

          // Hiển thị modal kết quả import
          this.importSuccess = response.code === 1000
          this.importResultMessage = this.importSuccess
            ? 'Import dữ liệu thành công'
            : response.message || 'Import dữ liệu thất bại'
          this.importResultData = response.data
          this.showImportResultModal = true

          // Nếu import thành công, cập nhật lại dữ liệu
          if (this.importSuccess) {
            await this.fetchData()
          }
        } catch (error) {
          console.error('Error importing file:', error)
          this.showLoading = false

          // Hiển thị modal kết quả import lỗi
          this.importSuccess = false
          this.importResultMessage = error.message || 'Có lỗi xảy ra khi import file'
          this.importResultData = null
          this.showImportResultModal = true
        }
      },
      async onFileChange(event) {
        const file = event.target.files[0]
        if (!file) return

        // Kiểm tra kiểu file
        const fileType = file.name.split('.').pop().toLowerCase()
        if (fileType !== 'xlsx' && fileType !== 'xls') {
          this.msgNoti = 'Vui lòng chọn file Excel (.xlsx, .xls)'
          this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
          this.notiModal = true
          this.$refs.fileInput.value = ''
          return
        }

        // Upload file và xử lý
        await this.importFile(file)

        // Reset input file để có thể chọn lại file cũ
        this.$refs.fileInput.value = ''
      },
      // Export excel function
      async exportExcel() {
        try {
          this.showLoading = true
          await DeviceService.dowTemplateTingboxsim({})
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>

<style></style>
